import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close-circle-2.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "userDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "userDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-rl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-title",
  id: "userDetailsModalLabel"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = { class: "modal-body p-0" }
const _hoisted_9 = {
  key: 0,
  class: "details-list list-style"
}
const _hoisted_10 = { class: "fs-14 text-title" }
const _hoisted_11 = { class: "fs-14 fw-bold text-title" }
const _hoisted_12 = { class: "fs-14 text-title" }
const _hoisted_13 = { class: "fs-14 fw-bold text-title" }
const _hoisted_14 = { class: "fs-14 text-title" }
const _hoisted_15 = { class: "fs-14 fw-bold text-title" }
const _hoisted_16 = { class: "fs-14 text-title" }
const _hoisted_17 = { class: "fs-14 fw-bold text-title" }
const _hoisted_18 = { class: "fs-14 text-title" }
const _hoisted_19 = { class: "fs-14 fw-bold text-title" }
const _hoisted_20 = { class: "fs-14 text-title" }
const _hoisted_21 = { class: "fs-14 fw-bold text-title" }
const _hoisted_22 = { class: "fs-14 text-title" }
const _hoisted_23 = { class: "fs-14 fw-bold text-title" }
const _hoisted_24 = { class: "fs-14 text-title" }
const _hoisted_25 = { class: "fs-14 fw-bold text-title" }
const _hoisted_26 = { class: "fs-14 text-title" }
const _hoisted_27 = { class: "fs-14 fw-bold text-title" }
const _hoisted_28 = { class: "fs-14 text-title" }
const _hoisted_29 = { class: "fs-14 fw-bold text-title" }
const _hoisted_30 = { class: "fs-14 text-title" }
const _hoisted_31 = { class: "fs-14 fw-bold text-title" }
const _hoisted_32 = { class: "fs-14 text-title" }
const _hoisted_33 = { class: "fs-14 text-title" }
const _hoisted_34 = { class: "fs-14 fw-bold text-title" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "fs-14 text-title" }
const _hoisted_37 = { class: "fs-14 fw-bold text-title" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "fs-14 text-title" }
const _hoisted_40 = { class: "fs-14 fw-bold text-title" }
const _hoisted_41 = {
  key: 1,
  class: "p-30 text-center"
}
const _hoisted_42 = { class: "text-paragraph" }
const _hoisted_43 = { class: "modal-footer pt-20 pb-35 justify-content-end" }
const _hoisted_44 = {
  type: "button",
  class: "btn style-four px-xxl-6",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("user_page.details_title")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close p-0",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.$t('common.close')
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("user_page.full_name")), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.fullName || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("user_page.username")), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.user.username || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("user_page.email")), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.user.email || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("user_page.phone")), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.user.phone || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("user_page.warehouse")), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.user.warehouse_name || _ctx.user.warehouse_code || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("user_page.branch")), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user.branch_name || _ctx.user.branch_code || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("user_page.biller")), 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.user.biller_name || _ctx.user.biller_code || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("user_page.role_permission")), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formatRole(_ctx.user.role_permission_id)), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("user_page.gender")), 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatGender(_ctx.user.gender)), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("user_page.company")), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.user.company || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("user_page.address")), 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.user.address || _ctx.$t("user_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("user_page.status")), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(['badge fs-14 fw-medium', (_ctx.user.active || _ctx.user.status === 'active') ? 'badge-success' : 'badge-danger'])
                  }, _toDisplayString((_ctx.user.active || _ctx.user.status === 'active') ? _ctx.$t("user_page.status_active") : _ctx.$t("user_page.status_inactive")), 3)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("user_page.created_at")), 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formatDateTime(_ctx.user.created_at)), 1)
                ]),
                (_ctx.user.last_login)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("user_page.last_login")), 1),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatDateTime(_ctx.user.last_login)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.ip_address)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("user_page.ip_address")), 1),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.user.ip_address), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("user_page.no_user_selected")), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.$t("common.close")), 1)
        ])
      ])
    ])
  ]))
}